import { Routes } from '@angular/router';
import { ErrorViewComponent } from './error-view/error-view.component';

export const routes: Routes = [
    {
        path: 'error',
        component: ErrorViewComponent,
    }
];
